import { apiClient } from './apiClient';

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: 'admin' | 'evaluator' | 'viewer';
  isActive: boolean;
  specialty?: string;
}

export interface UsersResponse {
  users: User[];
  total: number;
  page: number;
  limit: number;
}

export const userService = {
  // Obtener todos los usuarios evaluadores y admins activos
  async getEvaluators(): Promise<User[]> {
    try {
      const response = await apiClient.get('/users/evaluators');
      return response.data.evaluators;
    } catch (error) {
      console.error('Error obteniendo evaluadores:', error);
      return [];
    }
  },

  // Obtener usuario por ID
  async getUserById(id: string): Promise<User | null> {
    try {
      const response = await apiClient.get(`/users/${id}`);
      return response.data.user;
    } catch (error) {
      console.error('Error obteniendo usuario:', error);
      return null;
    }
  }
}; 